import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { createMetaManager } from 'vue-meta';

import gtag, { googleTagManager } from './utils/gtag';
import naverMap from './utils/naverMap';
import recaptcha from './utils/recaptcha';

import SetupCalendar, { Calendar, DatePicker } from 'v-calendar';
import { initMixpanel } from './utils/mixpanel';

import directive from './utils/directive';
import axiosInterceptor from './utils/axiosInterceptor';
import initializeStore from './utils/initializeStore';
import { printConsole } from './utils/console';
import { setupI18n } from '@/utils/i18n';
import { datadogLogs } from '@datadog/browser-logs';
import { initializeDatadog } from '@/utils/datadog';

const initSetup = async () => {
  const i18n = await setupI18n();
  const app = createApp(App);
  // Datadog 초기화
  if (import.meta.env.VITE_DATADOG_ENV === 'release' || import.meta.env.VITE_DATADOG_ENV === 'prod') {
    try {
      initializeDatadog();
    } catch (error) {
      console.error('Datadog initialization failed:', error);
    }
  }

  // Datadog에 에러 전송
  app.config.errorHandler = (error, instance, info) => {
    datadogLogs.logger.error('Vue Error', {
      componentName: instance?.$options.name || 'Unknown',
      error: error instanceof Error ? error.message : 'Unknown error',
      stack: error instanceof Error ? error.stack : 'No stack trace',
      info: info,
      route: router.currentRoute.value.path,
    });
  };

  app
    .use(createPinia())
    .use(router)
    .use(i18n)
    .use(directive)
    .use(axiosInterceptor)
    .use(initializeStore)
    .use(naverMap)
    .use(gtag)
    .use(recaptcha)
    .use(googleTagManager)
    .use(printConsole)
    .use(initMixpanel)
    .use(SetupCalendar, {})
    .use(createMetaManager())
    .component('Calendar', Calendar)
    .component('DatePicker', DatePicker)
    .mount('#app');
};
initSetup();
